import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql"
import { API } from "aws-amplify"

import {
  CreateArticleVoteInput,
  CreateArticleVoteMutation,
  CreateArticleVoteMutationVariables,
} from "../../../../api/graphql/API"
import { createArticleVote } from "../../../../graphql/mutations"

type AuthMode =
  | GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
  | GRAPHQL_AUTH_MODE.API_KEY

export const apiCreateArticleVote = async (
  reference: string,
  vote: number,
  reasons: string[],
  authMode: AuthMode = GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
) => {
  const _data = (await API.graphql({
    query: createArticleVote,
    variables: {
      input: {
        reference: reference,
        vote: vote,
        additional_data: JSON.stringify({ reasons: reasons }),
      } as CreateArticleVoteInput,
    } as CreateArticleVoteMutationVariables,
    authMode: authMode,
  })) as { data: CreateArticleVoteMutation }

  if (!_data || !_data.data || !_data.data.createArticleVote) {
    throw Error("No data received - something went wrong")
  }

  return _data.data.createArticleVote
}
